// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"buttonlang_Wrapper__A6auv","Eng":"buttonlang_Eng__1xzqe","Id":"buttonlang_Id__fbVWF","Active":"buttonlang_Active__2jLFd"};